
import "/app/src/pages/EnterpriseLibrary/EnterpriseFiles.module.less?modules";
export default {"info": `info-rZWx57xz`,"pdfIcon": `pdfIcon-scpB9-TS`,"imageIcon": `imageIcon-10NWhFyI`,"name": `name-j_BcGlZ5`,"list": `list-ATms55e2`,"file": `file-C2Zp5IYv`,"icon": `icon-yXe2eEEo`,"size": `size-nZTIzA7K`}
